// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LayerManager } from '@3d-scene/manager/layer-manager';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { ArticleRefreshData } from '@article/service/model/article-refresh-data';
import { ProjectChangedType } from '@project/model/project-changed';
import { ProjectModel } from '@project/model/project.model';
import { ProjectContentPresenter } from '@shared/presenter/project-content.presenter';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { MarkingSystemProjectCreationServiceDelegator } from '@configuration/wizard/service/marking-system-project-creation-service.delegator';
import { Log } from '@shared/debug/log';
import { IsProjectType } from '@project/model/is-project-type';

@Injectable({ providedIn: 'root' })
export class ApplicationRefreshService {

  constructor(
    private projectModel: ProjectModel,
    private articleContainerLoader: ArticleContainerLoader,
    private containerService: ContainerService,
    private markingSystemProjectCreationServiceDelegator: MarkingSystemProjectCreationServiceDelegator,
    private projectContentPresenter: ProjectContentPresenter,
    private layerManager: LayerManager,
    private detachArticleService: DetachArticleUsageService
  ) { }

  private get currentProject() {
    return this.projectModel.currentProject;
  }

  public async refreshProject(forceLoadArticles: boolean = true): Promise<boolean> {
    this.notifyProjectChange();
    if (forceLoadArticles) {
      const refreshData: ArticleRefreshData = new ArticleRefreshData();
      refreshData.isArticleRepresentationsEnabled = this.projectModel.isArticleRepresentationsEnabled();
      refreshData.updateTextures = !IsProjectType.markingSystem(this.currentProject);
      try {
        await this.articleContainerLoader.refreshContainers(this.containerService.enumerateArticleContainersInGlobal(), refreshData);
        await this.markingSystemProjectCreationServiceDelegator.projectRefreshedSuccess();
        this.projectModel.sendProjectChanged(ProjectChangedType.ProjectRefreshed);
      } catch (error) {
        Log.error(error);
        const articleDetached = await this.detachArticleService.detachArticleUsageFromProjectByIds(ArticleContainerUtils.extractArticleGUIDs(this.containerService.enumerateArticleContainersInGlobal()));
        if (articleDetached) {
          this.notifyProjectChange();
        }
        this.markingSystemProjectCreationServiceDelegator.errorHandler();
        return false;
      }
    }
    return true;
  }

  public notifyProjectChange() {
    this.notifyProjectChangeInternal();
  }

  public notifyProjectChangeInternal(
    // Workaround for GlobalContainer
    articleUsageIdsToRefresh: string[] = null) {
    // High priority, therefore direct call.
    this.projectContentPresenter.projectChangeHandler();
    this.projectModel.reset3DRepresentations();
    this.layerManager.queueUpdate();
    this.projectModel.sendProjectChanged(ProjectChangedType.ProjectChange, this.currentProject, articleUsageIdsToRefresh);
  }
}
